import { z } from 'zod';

export const NewAssetsSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  metadata: z
    .array(
      z.object({
        value: z.string().min(1),
        label: z.string().min(1),
      }),
    )
    .min(1, 'At least one tag is required')
    .default([]),
  thumbnail: z.instanceof(File).optional().nullable(),
  content: z.string().url('Must be a valid URL'),
  description: z
    .string()
    .min(1, 'Description is required')
    .max(500, 'Description must be less than 500 characters'),
  document: z
    .union([
      z.string().url('Must be a valid URL'),
      z.instanceof(File),
      z.null(),
    ])
    .nullable(),
});

export type NewAssetsFormValues = z.infer<typeof NewAssetsSchema>;

export const PreferencesSchema = z.object({
  industriesToExclude: z.array(z.string()).default([]),
  countriesToExclude: z.array(z.string()).default([]),
  companySizesToExclude: z.array(z.string()).default([]),
  minOfferDaac: z.coerce
    .number()
    .min(0.01, 'Must be 0.01 or greater')
    .default(0.01),
  minOfferDurationMonths: z.coerce
    .number()
    .min(1, 'Must be 1 or greater')
    .default(1),
  consentDataCollection: z.boolean().default(false),
  consentRevocableAck: z.boolean().default(false),
  consentPolicyAck: z.boolean().default(false),
});

export type PreferencesFormValues = z.infer<typeof PreferencesSchema>;

export const MonetiseSettingsSchema = z.object({
  price: z
    .string()
    .refine((val) => parseFloat(val) > 0, 'Price must be greater than 0'),
  percentage: z
    .number()
    .min(1, 'Percentage must be greater than 0')
    .max(100, 'Percentage must be 100 or less'),
  terms: z.boolean().refine((val) => val === true, 'You must accept the terms'),
});

export type MonetiseSettingsFormValues = z.infer<typeof MonetiseSettingsSchema>;
